
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import StickyCTA from '../../components/feature/StickyCTA';
import EspecialistasHeroSection from './components/EspecialistasHeroSection';
import MentorasSection from './components/MentorasSection';
import CTASection from './components/CTASection';

export default function EspecialistasPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <EspecialistasHeroSection />
      <MentorasSection />
      <CTASection />
      <Footer />
      <StickyCTA />
    </div>
  );
}
